import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import { Card } from "reactstrap";

import api from "../../services/api";
import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import FilterReportFranchisee from "./FilterReportFranchisee";
import {
  ReportFranchiseeContext,
  ReportFranchiseeContextProvider,
} from "../../context/ReportFranchiseeContext";
import MaskService from "../../utils/mask/maskService";
import { UserContext } from "../../context/UserContext";
import { GlobalVariables } from "../../global";
import "./reportFranchisee.css";
import Dashboard from "./Dashboard";

function createData(
  ClienteCNPJ,
  Razao,
  Familia,
  Produto,
  Versao,
  MotivoCancelamento,
  ValoresParametros,
  FranquiaCNPJ,
  Rota
) {
  return {
    ClienteCNPJ,
    Razao,
    Familia,
    Produto,
    Versao,
    MotivoCancelamento,
    ValoresParametros,
    FranquiaCNPJ,
    Rota,
  };
}

const headCells = [
  {
    name: "ClienteCNPJ",
    label: "CNPJ",
    align: "left",
  },
  {
    name: "Razao",
    label: "Razão",
    align: "left",
  },
  {
    name: "Familia",
    label: "Família",
    align: "center",
  },
  {
    name: "Produto",
    label: "Produto",
    align: "center",
  },
  {
    name: "Versao",
    label: "Versão",
    align: "center",
  },
  {
    name: "Rota",
    label: "Nome de Acesso",
    align: "left",
  },
  {
    name: "MotivoCancelamento",
    label: "Status",
    align: "center",
  },
  {
    name: "ValoresParametros",
    label: "Parâmetros",
    align: "center",
  },
];

function EnhancedTableHead() {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.name}
            padding={"default"}
            align={headCell.align}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  row: {
    margin: "1px",
  },
}));

const View = () => {
  const {
    cnpj,
    setValuesTable,
    reason,
    family,
    product,
    version,
    status,
    segment,
    franchisee,
    setValuesDash,
  } = useContext(ReportFranchiseeContext);
  const { user } = useContext(UserContext);
  const { push } = useHistory();
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [rowsFilter, setRowsFilter] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        if (GlobalVariables.TIPO_PROMOTOR_FRANQUIA !== user.IdTipoPromotor) {
          push("/homePage");
          return notify(
            "Este relatório é apenas para usuários vinculados a uma franquia."
          );
        }

        let route = `relatorio/franquia/${user.PromotorCNPJ}`;

        if (user.IdTipoUsuario === GlobalVariables.ADM_QYON) {
          route = "relatorio/franquia";
        }

        const { data: response } = await api.get(route);

        const employees = response.data.map((employee, index) => {
          return createData(
            employee.ClienteCNPJ,
            employee.Razao,
            employee.Familia,
            employee.Produto,
            employee.Versao,
            employee.MotivoCancelamento,
            employee.ValoresParametros,
            employee.FranquiaCNPJ,
            employee.Rota
          );
        });

        setValuesTable(response.data);
        setRows(employees);
        setRowsFilter(employees);
        setAllRows(response.data);
        setLoading(false);
      } catch (error) {
        console.error("ERROR: PreviewReportFranchisee fechData", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [setValuesTable, user, push]);

  useEffect(() => {
    try {
      setLoadingFilter(true);
      const dashboard = {};
      const newRowsFilter = [...allRows].filter((element) => {
        if (
          (!cnpj ||
            element.ClienteCNPJ.toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[^a-z0-9]/gi, "")
              .indexOf(
                cnpj
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[^a-z0-9]/gi, "")
              ) !== -1) &&
          (!reason ||
            element.Razao.toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[^a-z0-9]/gi, "")
              .indexOf(
                reason
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[^a-z0-9]/gi, "")
              ) !== -1) &&
          (!family || element.IdFamilia === family.Id) &&
          (!product || element.IdProduto === product.Id) &&
          (!version || element.IdVersao === version.Id) &&
          (!segment || element.IdSegmento === segment.Id) &&
          (!status || element.IdMotivoCancelamento === status.Id) &&
          (!franchisee || element.FranquiaCNPJ === franchisee.CNPJ)
        ) {
          dashboard[element.ClienteCNPJ] = {
            Id: element.IdMotivoCancelamento,
            Descricao: element.MotivoCancelamento,
          };

          return true;
        } else {
          return false;
        }
      });

      setValuesDash(dashboard);
      setRowsFilter(newRowsFilter);
      setPage(0);
      setLoadingFilter(false);
    } catch (error) {
      console.error("ERROR PreviewReportFranchisee filter:", error);
      setLoadingFilter(false);
    }
  }, [
    cnpj,
    reason,
    family,
    product,
    version,
    status,
    franchisee,
    segment,
    allRows,
    setValuesDash,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <>
      <ModalLoading loading={loading || loadingFilter ? true : false} />

      <div>
        <div className="containerTable">
          <FilterReportFranchisee />
          <Dashboard />

          <Card className="card-default">
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  rowCount={rowsFilter.length}
                />
                <TableBody>
                  {rowsFilter
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow hover tabIndex={-1} key={index}>
                          <TableCell align="left">
                            {MaskService.toMask("cnpj", row.ClienteCNPJ)}
                          </TableCell>
                          <TableCell align="left">{row.Razao}</TableCell>
                          <TableCell align="center">{row.Familia}</TableCell>
                          <TableCell align="center">{row.Produto}</TableCell>
                          <TableCell align="center">{row.Versao}</TableCell>
                          <TableCell align="left">{row.Rota}</TableCell>
                          <TableCell align="center">
                            {row.MotivoCancelamento}
                          </TableCell>
                          <TableCell align="center">
                            {row.ValoresParametros &&
                              row.ValoresParametros !== "{}" && (
                                <Tooltip
                                  title={Object.keys(
                                    JSON.parse(row.ValoresParametros)
                                  ).map((key, index) => (
                                    <label
                                      key={index}
                                      className="tooltip-label"
                                    >
                                      {`${key}:  ${
                                        JSON.parse(row.ValoresParametros)[key]
                                      }`}
                                    </label>
                                  ))}
                                >
                                  <VisibilityOutlinedIcon className="eye-params" />
                                </Tooltip>
                              )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={9} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={rowsFilter.length}
              rowsPerPage={rowsPerPage}
              page={page}
              labelRowsPerPage={"Linhas por página"}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Card>
        </div>
      </div>
    </>
  );
};

const PreviewReportFranchisee = (props) => (
  <ReportFranchiseeContextProvider>
    <View {...props} />
  </ReportFranchiseeContextProvider>
);

export { PreviewReportFranchisee };
